import { render } from "./SwitchStatusBtnComp.vue?vue&type=template&id=082ee307"
import script from "./SwitchStatusBtnComp.vue?vue&type=script&lang=js"
export * from "./SwitchStatusBtnComp.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__